import {Component, OnInit} from '@angular/core';
import {CoreService} from '../../helper/core/core.service';
import {ActivatedRoute, Router, ParamMap} from '@angular/router';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {BuNameService} from '../../helper/core/bu-name.service';
import {UserService} from '../../helper/core/user.service';
import {UtilsService} from '../../helper/utils/utils.service';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Constant} from '../../helper/core/constant';

@Component({
  selector: 'app-invite-friend',
  templateUrl: './invite-friend.component.html',
  styleUrls: ['./invite-friend.component.scss']
})
export class InviteFriendComponent implements OnInit {

  public idSlot: string = "";
  public idRegistration: any;
  public idUser: any;
  public event: any = false;
  public errorMsg: string = "";
  public errorApi: boolean = false;
  public timezone: string;

  shareForm: FormGroup;
  shareEmail: FormControl;

  constructor(
    private builder: FormBuilder,
    private constant: Constant,
    private coreService: CoreService,
    private route: ActivatedRoute,
    private router: Router,
    private buNameService: BuNameService,
    private userService: UserService,
    private utils: UtilsService
  ) {
  }

  ngOnInit() {

    $(document).ready(function () {
      $(document).foundation();
    });

    // On récupère l'id du Slot
    this.route
      .queryParamMap
      .subscribe((params: ParamMap) => {
        this.idSlot = params.get('id');
        this.idRegistration = params.get('user');
      });

    /**
     * On appelle les informations de l'évènements
     * En fonction du crénau choisi
     */
    this.getSlotInformation(this.idSlot);

    registerLocaleData(localeFr, 'fr');

    // Validator du champ email
    this.shareEmail = new FormControl('', [
      Validators.required,
      Validators.pattern(this.constant.emailPattern)
    ]);
    // Construction de la composition du formulaire
    this.shareForm = this.builder.group({
      email: this.shareEmail,
    });

  }

  /**
   * API Récupère les informations
   * de l'évènement par l'id du Slot
   * @param idSlot | String : id du Slot
   */
  private getSlotInformation(idSlot): void {
    this.coreService.getSlot(idSlot).subscribe(
      (data) => {

        // Attribution des éléments de event
        this.event = data;
        this.timezone = data.currentGmt;

        // Attribution du nom de la BU dans le header
        this.buNameService.name = data.bu_name;
        // Attribution de l'url de la BU dans le header
        this.buNameService.url = data.buSlug;
        // Attribution de l'img de la BU dans le header
        this.buNameService.img = (typeof data.buLogo != "undefined") ? data.buLogo : "default";
        // Changement de title du site
        this.buNameService.title = data.name;

      }, (dataError) => {
        this.errorApi = true;
      });
  }


  onSubmit() {
    if (this.shareForm.valid) {

      // On request pour se désinscrire
      const obj = {
        idRegistration: this.idRegistration,
        email: this.shareEmail.value,
      };
      this.errorMsg = "";

      // Api de désinscription
      this.coreService.shareAnEvent(this.event.slug, obj).subscribe(
        () => {
          this.errorMsg = "Votre invitation a bien été envoyée.";
          $('html, body').animate({
            scrollTop: 0
          }, 750);
        }, (dataError) => {
          // Message d'erreur de désinscription
          this.errorMsg = dataError;
          this.utils.scrollTo(".header__container");
        });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/screens/invite-friend/invite-friend.component.ts